import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './static/css/iconfont.css'//引入阿里巴巴图标库css
import './static/css/iconfont.js' //引入阿里巴巴图标库js
import { ipURL,baseURL} from '@/config/net.config.js'
import './static/css/public.css'

import './static/css/my.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.use(ElementUI);
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.meta.isLogin) {
    if (sessionStorage.getItem('userId')) {
      next()
    } else {
      ElementUI.MessageBox.confirm('您好, 请先登录！', '系统提示', {
        confirmButtonText: '返回',
        cancelButtonText: '登录',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonClass: "cancelButtonClass",
        confirmButtonClass: "confirmButtonClass",
        callback: function (action, instance) {
          console.log(instance);
          // 返回主页
          if (action == "confirm") {
            next('/serviceHome')
          }
          // 登录
          if (action == "cancel") {
            window.location.href = ipURL +'/cas/login?service='+baseURL+'/index'
          }
        },
      })
    }
  } else {
    next()
  }
})

new Vue({
  Video,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

